export enum FolderChangeActionType {
  Add = 'ADD',
  Copy = 'COPY',
  Restore = 'RESTORE',
  Delete = 'DELETE',
  DeleteFromTrash = 'DELETE_FROM_TRASH',
  Edit = 'EDIT',
  Rename = 'RENAME',
  Move = 'MOVE',
  InfoUploaded = 'INFO_UPLOADED',
  Lock = 'LOCK',
  Unlock = 'UNLOCK',
  ChangeInProgress = 'CHANGE_IN_PROGRESS',
  PreviewDone = 'PREVIEW_DONE',
  AddFolder = 'ADD_FOLDER',
  RenameFolder = 'RENAME_FOLDER',
  MoveFolder = 'MOVE_FOLDER',
  RestoreFolder = 'RESTORE_FOLDER',
  DeleteFolder = 'DELETE_FOLDER',
}